import { FC, useLayoutEffect, useRef } from 'react';
import { Button } from 'antd';

import { Verify2FAStepProps } from 'models/form';

import { useTranslate } from 'hooks';

export const VerifySuccessful: FC<Verify2FAStepProps> = ({ onClose }) => {
	const ref = useRef<HTMLInputElement>(null);

	const { gotItText } = useTranslate(['gotItText']);

	useLayoutEffect(() => {
		if (ref?.current) {
			ref.current.focus();
		}
	}, []);

	return (
		<div className="modal-content">
			<br />

			<Button ref={ref} type="primary" className="modal-button" onClick={onClose}>
				{gotItText}
			</Button>
		</div>
	);
};
